<template>
  <v-tabs>
    <v-tab href="#searchInput">Search Input</v-tab>
    <v-tab-item value="searchInput">
      <v-row dense>
        <!-- address -->
        <v-col cols="6">
          <span class="overline">Address</span>
          <div v-if="searchCase.address" cols="6">
            {{ searchCase.address.address1 }}
            {{ searchCase.address.address2 }}
            {{ searchCase.address.address3 }}
            {{ searchCase.address.address4 }}
            <br />
            {{ searchCase.address.city }}
            {{ searchCase.address.stateOrProvince }}
            {{ searchCase.address.postalCode }}
            <br />
            {{ searchCase.address.country }}
          </div>
          <div v-else cols="6">NA</div>
        </v-col>

        <!-- local ID -->
        <v-col cols="6" v-if="searchCase.localId">
          <div class="overline">Local ID</div>
          {{ searchCase.localId }}
        </v-col>

        <!-- citizenship and dob -->
        <v-col cols="6" v-if="searchCase.citizenship">
          <div class="overline">Citizenship</div>
          {{ searchCase.citizenship }}
        </v-col>

        <v-col cols="6" v-if="searchCase.dob">
          <div class="overline">DOB</div>
          {{ searchCase.dob }}
        </v-col>

        <!-- SSN  -->
        <!-- <v-col cols="6" v-if="searchCase.ssnLast4">
          <div class="overline">SSN</div>
          {{ "**** " + searchCase.ssnLast4 }}
        </v-col> -->

        <!-- Tax ID -->
        <v-col cols="6" v-if="searchCase.taxId">
          <div class="overline">Tax ID</div>
          {{ searchCase.taxId }}
        </v-col>

        <!-- passport  -->
        <v-col cols="6" v-if="searchCase.passport">
          <div class="overline">Passport</div>
          {{ getPassportString(searchCase.passport) }}
        </v-col>

        <!-- drivers license  -->
        <v-col cols="6" v-if="searchCase.driversLicense">
          <div class="overline">Drivers License</div>
          {{ getDLString(searchCase.driversLicense) }}
        </v-col>

        <!-- phone  -->
        <v-col cols="6">
          <div class="overline" v-if="searchCase.phoneNumber">Phone Number</div>
          {{ searchCase.phoneNumber }}
        </v-col>

        <!-- gender  -->
        <v-col cols="6" v-if="searchCase.gender">
          <div class="overline">Gender</div>
          {{ searchCase.gender }}
        </v-col>
      </v-row>
    </v-tab-item>
     <v-tab href="#sources">Sources</v-tab>
    <v-tab-item value="sources">
      <v-row dense>
        <v-col>
          <span
            v-for="source in sources"
            :key="source.source"
          >
            <span class="font-weight-bold">{{ source.source }}</span>
            {{ source.publishDate }}
            <br />
          </span>
        </v-col>
      </v-row>
    </v-tab-item>
    <v-tab href="#additionalData" :disabled="!searchCase.caseAttributes">
      Additional Data ({{
        searchCase.caseAttributes
          ? Object.keys(searchCase.caseAttributes).length
          : "0"
      }})
    </v-tab>
    <v-tab-item value="additionalData">
      <v-row dense>
        <v-col cols="6" v-if="searchCase.localId">
          <div class="overline font-weight-black">Local ID</div>
          {{ searchCase.localId }}
        </v-col>
        <v-col
          v-for="(value, propertyName) in searchCase.caseAttributes"
          :key="propertyName"
          cols="6"
        >
          <div class="overline">{{ propertyName }}</div>
          {{ value }}
        </v-col>
      </v-row>
    </v-tab-item>
  </v-tabs>
  <!-- </v-card-text>
  </v-card> -->
</template>

<script>
export default {
  name: "CaseDetailsFullScreen",
  components: {},
  props: {
    searchCase: {},
    sources: {},
    elevation: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    getPassportString(passport) {
      if (!passport || Object.keys(passport).length === 0) {
        return "NA";
      } else {
        let passportString = "";
        if (passport.passportNumber) {
          passportString += passport.passportNumber + " ";
        }
        if (passport.passportCountry) {
          passportString += passport.passportCountry;
        }
        return passportString;
      }
    },
    getDLString(dl) {
      if (!dl || Object.keys(dl).length === 0) {
        return "NA";
      } else {
        let dlString = "";
        if (dl.licenseNumber) {
          dlString += dl.licenseNumber + " ";
          if (dl.licenseCountry) {
            dlString += dl.licenseCountry;
          }
        }
        return dlString;
      }
    },
  },
};
</script>
